/**
 * EliorGroup.Joyfood.B2B API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface B2BUpdateCustomerCommand { 
    username?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    employeeId?: string | null;
    readonly azureAdUpn?: string | null;
    readonly azureAdUsername?: string | null;
    readonly otp?: string | null;
    role: number;
    siteIds: Array<number>;
    accessCode?: string | null;
    unlockCode?: string | null;
    taxId?: string | null;
    terminationDate?: string | null;
}

